import { StandardEntity } from '@infodata-group/inf-commons';

export class Urgency extends StandardEntity {
  public priority: number;
  public iconTable: string;
  public color: string;

  constructor(id: string, label: string, priority: number) {
    super(id, label, 'full');
    this.priority = priority;
    if (priority === -1) {
      this.color = '99abb2';
    }
  }
}
